import React, { useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import * as Yup from "yup";

import Screen from "../components/Screen";
import { AppForm, AppFormField, SubmitButton } from "../components/forms";
import useUser from "../hooks/useUser";
import AppButton from "../components/AppButton";
import config from "../config/config";
import useApi from "../hooks/useApi";
import authApi from "../api/auth";
import routes from "../navigation/routes";

const validationSchema = Yup.object().shape({
    email: Yup.string().required().email().label("Email"),
    password: Yup.string().required().min(4).label("Password"),
});

function LoginScreen({ navigation }) {
    const [message, setMessage] = useState();

    const loginApi = useApi(authApi.login);
    const { logIn } = useUser();

    const handleSubmit = async ({ email, password }) => {
        const response = await loginApi.request(email, password);
        if (!response.ok) {
            setMessage("Log in unsuccessful");
            return;
        }
        logIn(response.data);
        navigation.goBack();
    };

    return (
        <Screen loading={loginApi.loading} title={"Login"} navigation={navigation} message={message} setMessage={setMessage}>
            <ScrollView>
                <View style={styles.container}>
                    <AppForm initialValues={{ email: "", password: "" }} onSubmit={handleSubmit} validationSchema={validationSchema}>
                        <AppFormField
                            autoCapitalize="none"
                            autoCorrect={false}
                            icon="email"
                            keyboardType="email-address"
                            name="email"
                            placeholder="Email"
                            textContentType="emailAddress"
                            autoFocus={true}
                        />
                        <AppFormField
                            autoCapitalize="none"
                            autoCorrect={false}
                            icon="lock"
                            name="password"
                            placeholder="Password"
                            secureTextEntry
                            textContentType="password"
                        />
                        <SubmitButton title="Login" />
                    </AppForm>
                    <AppButton title="Reset Password" color={config.colors.tertiary} onPress={() => navigation.navigate(routes.RESET_PASSWORD)} />
                </View>
            </ScrollView>
        </Screen>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 20,
    },
});

export default LoginScreen;
